import React, { useRef } from 'react';
import experiences from '../../data/experiences';
import useActiveIndex from '../Utils/useActiveIndex';
import useScrollProgress from '../Utils/useScrollProgress';
import TimelineItem from './TimelineItem';
import styles from './Timeline.module.css';

/**
 * Vertical experience timeline: newest at the top, oldest at the bottom.
 * A cyan rail fills as you scroll and the node nearest the viewport centre
 * lights up.
 */
export default function Timeline() {
  const listRef = useRef(null);
  const progress = useScrollProgress(listRef);
  const { setItemRef, activeIndex } = useActiveIndex(experiences.length);

  return (
    <section className={styles.section} id="experience" aria-labelledby="experience-heading">
      <header className={styles.header}>
        <p className="mc-eyebrow">01 / Experience</p>
        <h2 id="experience-heading" className={styles.heading}>
          Where I&apos;ve built things
        </h2>
      </header>

      <div className={styles.rail} ref={listRef}>
        {/* Static hairline + cyan progress overlay */}
        <span className={styles.track} aria-hidden="true" />
        <span
          className={styles.trackFill}
          aria-hidden="true"
          style={{ transform: `scaleY(${progress})` }}
        />

        <ol className={styles.list}>
          {experiences.map((item, i) => (
            <TimelineItem
              key={item.id}
              item={item}
              active={i === activeIndex}
              innerRef={setItemRef(i)}
            />
          ))}
        </ol>
      </div>
    </section>
  );
}
